import { render, staticRenderFns } from "./TreeRequest.vue?vue&type=template&id=4291afb2&scoped=true"
import script from "./TreeRequest.vue?vue&type=script&lang=ts"
export * from "./TreeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291afb2",
  null
  
)

export default component.exports